import { format } from 'date-fns';
import { TNullable } from '~/types/Nullable';

export const formatExperienceDates = (
  startsAt: string,
  endsAt: TNullable<string>,
  isCurrentEmployer: boolean,
): string => {
  const formattedStart = format(new Date(startsAt), 'MMMM dd, yyyy');

  if (isCurrentEmployer) {
    return `${formattedStart} / Present`;
  }

  if (endsAt) {
    const formattedEnd = format(new Date(endsAt), 'MMMM dd, yyyy');
    return `${formattedStart} / ${formattedEnd}`;
  }

  return formattedStart;
};

export const formatGraduationDate = (graduatesAt: TNullable<string>): string => {
  if (!graduatesAt) {
    return '-';
  }

  return format(new Date(graduatesAt), 'MMMM dd, yyyy');
};
